import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { stat } from 'original-fs';
import { prepareFormObjectForSave } from '@/core/tools/forms/prepare_form_object_for_save';

interface DeliverySheetBoardState {
    employeeId: string | null;
    view: string | null;

    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    data: any;
    period: any;
    period_schema: any;

    header_1: any[];
    header_2: any[];
    displayCols: any[];

    ds: any[];
    filter: string;
}

const state: DeliverySheetBoardState = {
    employeeId: null,
    view: null,

    loading: false,
    loaded: false,
    fatalError: false,

    data: null,
    period: null,
    period_schema: null,

    header_1: [],
    header_2: [],
    displayCols: [],

    ds: [],
    filter: '',
};


export const actions: ActionTree<DeliverySheetBoardState, RootState> = {
    // changeFilterValue({ commit, getters, dispatch, state }, {field, newValue}) {
    //     (state as any)[field] = newValue;
    //     if (state.cityId && state.deliveryDate) {
    //         dispatch('loadDeliverySheetData', { cityId: state.cityId, deliveryDate: state.deliveryDate })
    //     }
    // },

    setFilterValue({ commit, getters, dispatch, state }, query) {
      state.employeeId = query.employeeId
      state.view = query.view

      if (state.employeeId) {
          dispatch('loadData', { employeeId: state.employeeId, view: state.view })
      }
    },

    loadData({ commit, getters, dispatch, state }, { employeeId, view }) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
        commit('START_LOADING');
        let date = moment()
        if (date.date() >= 25) {
          date = date.add(1, 'month').startOf('month')
        }

        vm.$db([
            vm.$q('PLANING_DATA')
                .raw(view == 'weight' ? 'planfact.month' : 'planfact.month.money')
                .action({
                  employee_id: employeeId,
                  date: date.startOf('month').format('YYYY-MM-DD')
                }),
            vm.$q('PERIOD_ROW')
                .raw('documents.list')
                .action({
                  columns: {
                    id: 'period.id',
                    employee_id: 'period.employee_id',
                    date: 'period.date',
                    closed_at: 'period.closed_at',
                  },
                  from: 's:periods',
                  from_as: 'period',
                  where: {
                    $and: [
                      { $eq: ['period.employee_id', {$: employeeId}] },
                      { $eq: ['period.date', {$: date.format('YYYY-MM-DD')}] },
                    ]
                  }
                }),
        ]).then(((result: ServerResult) => {
            commit('SET_DATA', result.getOperation('PLANING_DATA').getContent());
            commit('SET_FILTER', '');
            commit('SET_PERIOD', result.getOperation('PERIOD_ROW').getContent());
            commit('LOADED_SUCCESS');

            resolve();
        }));
      })
    },

    closePeriod({state, commit}) {
      return new Promise((resolve, reject) => {
        commit('START_LOADING');
        const vm = (this as any)._vm;

        let date = moment()
        if (date.date() >= 25) {
          date = date.add(1, 'month').startOf('month')
        }
        const normalizedForm = prepareFormObjectForSave(state.period_schema, {
          employee_id: state.employeeId,
          date: date.startOf('month').format('YYYY-MM-DD'),
          updated_at: moment().toISOString(),
          closed_at: moment().toISOString(),
        });

        let saveQuery = null;

        if (state.period) {
          saveQuery = vm.$q('SAVE')
              .update(state.period.id, normalizedForm)
      } else {
          saveQuery = vm.$q('SAVE')
              .create('s:periods', normalizedForm)
        }
        vm.$db([
          saveQuery
        ]).then(((result: ServerResult) => {
          commit('LOADED_SUCCESS');
          commit('SET_PERIOD', result.getOperation('SAVE').getContent());
          resolve();
        }));
      })
    },

    changePlan({ state, commit }, {clientId, productId, productContainerId, index, value}) {
      const data = JSON.parse(JSON.stringify(state.data.data))
      // const ds = JSON.parse(JSON.stringify(state.ds))

      // tslint:disable-next-line:forin
      for (const catIndex in data) {
        // tslint:disable-next-line:forin
        for (const clientIndex in data[catIndex].clients) {
          if (data[catIndex].clients[clientIndex].client_id !== clientId) {
            continue;
          }

          const productIndex = data[catIndex].clients[clientIndex].products.findIndex((_product: any) => {
            return _product.product_id === productId
          });

          if(productIndex > -1) {
            const targetIndex = data[catIndex].clients[clientIndex].products[productIndex].product_containers.findIndex((_product: any) => {
              return _product.product_container_id === productContainerId
            });

            if(targetIndex > -1) {
              data[catIndex].clients[clientIndex].products[productIndex].product_containers[targetIndex].weeks[index].plan = parseInt(value)

              state.data.revision = state.data.revision ? state.data.revision + 1 : 1
            }
          }
        }
      }

      state.data.data = data;
      // state.ds = ds;
      commit('SET_DATA', state.data)
      commit('SET_FILTER', state.filter)
      // return { ...state };
    },

    changeMonthPlan({ state, commit }, {clientId, productId, productContainerId, value}) {
      const data = JSON.parse(JSON.stringify(state.data.data))
      const ds = JSON.parse(JSON.stringify(state.ds))

      // tslint:disable-next-line:forin
      for (const catIndex in data) {
        // tslint:disable-next-line:forin
        for (const clientIndex in data[catIndex].clients) {
          if (data[catIndex].clients[clientIndex].client_id !== clientId) {
            continue;
          }

          // const targetIndex = data[catIndex].clients[clientIndex].products.findIndex((_product: any) => {
          //   return _product.product_id === productId;
          // });


          const productIndex = data[catIndex].clients[clientIndex].products.findIndex((_product: any) => {
            return _product.product_id === productId
          });
          console.log('productIndex', productIndex)

          if(productIndex > -1) {
            const targetIndex = data[catIndex].clients[clientIndex].products[productIndex].product_containers.findIndex((_product: any) => {
              return _product.product_container_id === productContainerId
            });

            console.log('targetIndex', targetIndex)

            if(targetIndex >= 0) {
              // data[catIndex].clients[clientIndex].products[productIndex].product_containers[targetIndex].weeks[index].plan = parseInt(value)
              const midValue = parseInt(value) / (data[catIndex].clients[clientIndex].products[productIndex].product_containers[targetIndex].weeks.length - 1);

              data[catIndex].clients[clientIndex].products[productIndex].product_containers[targetIndex].weeks =
              data[catIndex].clients[clientIndex].products[productIndex].product_containers[targetIndex].weeks.map((weekData: any, idx: number) => {
                if (idx === 0) {
                  return weekData
                } else {
                  return {
                    ...weekData,
                    // @ts-ignore
                    plan: parseInt(midValue)
                  };
                }
              });

              state.data.revision = state.data.revision ? state.data.revision + 1 : 1
            }
          }

          // if (targetIndex > -1) {
          //   const midValue = parseInt(value) / data[catIndex].clients[clientIndex].products[targetIndex].weeks.length;

          //   data[catIndex].clients[clientIndex].products[targetIndex].weeks =
          //     data[catIndex].clients[clientIndex].products[targetIndex].weeks.map((weekData: any) => {
          //       return {
          //         ...weekData,
          //         // @ts-ignore
          //         plan: parseInt(midValue)
          //       };
          //     });

          //   state.data.revision = state.data.revision ? state.data.revision + 1 : 1
          // }
        }
      }

      state.data.data = data;
      // state.ds = ds;
      commit('SET_DATA', state.data)
      commit('SET_FILTER', state.filter)
      // return { ...state };
    },

    savePlanChanges({ commit, state }) {
      const vm = (this as any)._vm;
      const allData: any[] = [];

      for(const catIndex in state.data.data) {
        for(const clientIndex in state.data.data[catIndex].clients) {
          for(const productIndex in state.data.data[catIndex].clients[clientIndex].products) {

            for(const containerIndex in state.data.data[catIndex].clients[clientIndex].products[productIndex].product_containers) {

              for(const weekIndex in state.data.data[catIndex].clients[clientIndex].products[productIndex].product_containers[containerIndex].weeks) {
                const weekData = state.data.data[catIndex].clients[clientIndex].products[productIndex].product_containers[containerIndex].weeks[weekIndex]

                if(weekData.plan !== null) {
                  allData.push({
                    client_id: `d:clients:${state.data.data[catIndex].clients[clientIndex].client_id}`,
                    product_id: `d:products:${state.data.data[catIndex].clients[clientIndex].products[productIndex].product_containers[containerIndex].product_id}`,
                    product_container_id: `d:product_containers:${state.data.data[catIndex].clients[clientIndex].products[productIndex].product_containers[containerIndex].product_container_id}`,
                    date: state.data.current_month_weeks[weekIndex],
                    plan: weekData.plan,
                    month: state.data.current_month,
                  });
                }
              } //

            }

          }
        }
      }

      return new Promise((resolve, reject) => {
        commit('START_LOADING');

        vm.$db([
          vm.$q('PLANING_SAVE_DATA')
            .raw('planfact.month.set')
            .action({
              client_week_plans: allData
            }),
        ]).then(((result: ServerResult) => {
          commit('LOADED_SUCCESS');
          commit('ON_SAVE');

          resolve();
        }));
      })

    },
    setFilter({commit}, term) {
      commit('SET_FILTER', term);
    }
};

export const mutations: MutationTree<DeliverySheetBoardState> = {
  START_LOADING: (state) => {
      // state.loaded = false;
      state.fatalError = false;
  },

  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.fatalError = false;
  },

  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.fatalError = true;
  },

  ON_SAVE: (state) => {
    state.data.revision = 0;
  },

  SET_PERIOD: (state, data) => {
    if (data.document) {
      state.period = data.document
    } else {
      state.period = data.documents.length > 0 ? data.documents['0'] : null
    }
    state.period_schema = data.schema
  },

  SET_DATA: (state, data) => {
    console.log(data)

    if (!data) return;
    state.data = data;
    state.data.revision = state.data.revision || 0;
  },

  SET_FILTER(state: DeliverySheetBoardState, term: string) {
    if (!state.data) {
      return []
    }
    state.filter = term.toLowerCase()

    state.ds = state.data.data.reduce((ac: any[], category: any) => {
      const categoryData: any = {
        type: 'category',
        name: category.client_category_profit
      };

      ac.push(categoryData);

      for (const client of category.clients) {
        let products: any[] = [];

        if (!client.client_name.toLowerCase().includes(state.filter) && state.filter) {
          continue
        }

        for (const product of client.products) {
          const containers = [];

          for (const container of product.product_containers) {

            const current_month_plan = container.weeks.reduce((ac: any, row: any) => {
              return ac + row.plan || 0;
            }, 0);

            const current_month_delta = current_month_plan - container.current_month_fact;

            containers.push({
              type: 'container',
              ...container,
              product_id: product.product_id,
              name: `${product.product_name} - ${container.product_container_name}`,
              current_month_plan,
              current_month_delta,
              client_id: (client as any).client_id,
            });
          }

          products = [
            ...products,
            {
              type: 'product',
              ...product,
              name: product.product_name,
              prev_months_facts: containers.reduce((ac, current) => {
                for(const key in current.prev_months_facts) {
                  ac[key] = ac[key] ? ac[key] + current.prev_months_facts[key] : current.prev_months_facts[key];
                }

                return ac;
              }, []),
              prev_months_average: containers.reduce((ac, current) => ac + current.prev_months_average, 0),
              current_month_prev_year_fact: containers.reduce((ac, current) => ac + current.current_month_prev_year_fact, 0),
              current_month_fact: containers.reduce((ac, current) => ac + current.current_month_fact, 0),
              current_month_plan: containers.reduce((ac, current) => ac + current.current_month_plan, 0),
              current_month_delta: containers.reduce((ac, current) => ac + current.current_month_delta, 0),
              weeks: containers.reduce((ac, current) => {
                for(const key in current.weeks) {
                  if(!ac[key]) {
                    ac[key] = {};
                  }

                  ac[key].plan = (ac[key].plan || 0) + current.weeks[key].plan;
                  ac[key].fact = (ac[key].fact || 0) + current.weeks[key].fact;
                }

                return ac;
              }, []),
              client_id: (client as any).client_id,
            },
            ...containers
          ]
        }

        const cleanProducts = products.filter((product: any) => product.type =='product');

        const clientData: any = {
          type: 'client',
          name: (client as any).client_name,
          client_id: (client as any).client_id,
          isExpanded: (client as any).isExpanded,

          prev_months_facts: cleanProducts.reduce((ac, current) => {
            for(const key in current.prev_months_facts) {
              ac[key] = ac[key] ? ac[key] + current.prev_months_facts[key] : current.prev_months_facts[key];
            }

            return ac;
          }, []),
          prev_months_average: cleanProducts.reduce((ac, current) => ac + current.prev_months_average, 0),
          current_month_prev_year_fact: cleanProducts.reduce((ac, current) => ac + current.current_month_prev_year_fact, 0),
          current_month_fact: cleanProducts.reduce((ac, current) => ac + current.current_month_fact, 0),
          current_month_plan: cleanProducts.reduce((ac, current) => ac + current.current_month_plan, 0),
          current_month_delta: cleanProducts.reduce((ac, current) => ac + current.current_month_delta, 0),
          weeks: cleanProducts.reduce((ac, current) => {
            for(const key in current.weeks) {
              if(!ac[key]) {
                ac[key] = {};
              }

              ac[key].plan = (ac[key].plan || 0) + current.weeks[key].plan;
              ac[key].fact = (ac[key].fact || 0) + current.weeks[key].fact;
            }

            return ac;
          }, []),
        };

        clientData.products = products;

        ac.push(clientData);

        categoryData.prev_months_facts = clientData.prev_months_facts.reduce((ac: any, current: any, mInd: any) => {
          ac[mInd] = ac[mInd] ? ac[mInd] + current : current;

          return ac;
        }, categoryData.prev_months_facts || []),
        categoryData.prev_months_average = (categoryData.prev_months_average || 0) + clientData.prev_months_average;
        categoryData.current_month_prev_year_fact = (categoryData.current_month_prev_year_fact || 0) + clientData.current_month_prev_year_fact;
        categoryData.current_month_fact = (categoryData.current_month_fact || 0) + clientData.current_month_fact;
        categoryData.current_month_plan = (categoryData.current_month_plan || 0) + clientData.current_month_plan;
        categoryData.current_month_delta = (categoryData.current_month_delta || 0) + clientData.current_month_delta;
        categoryData.weeks = clientData.weeks.reduce((ac: any, current: any, wInd: any) => {
          if (!ac[wInd]) { ac[wInd] = {}; }

          ac[wInd].plan = (ac[wInd].plan || 0) + current.plan;
          ac[wInd].fact = (ac[wInd].fact || 0) + current.fact;

          return ac;
        }, categoryData.weeks || []);

      }

      return ac;
    }, []);


    const categories = state.ds.filter((row: any) => row.type === 'category');
    const summaryData: any = {
      type: 'summary',
      name: 'Общие итоги',

      prev_months_facts: categories.reduce((ac: any, current: any) => {
        for(const key in current.prev_months_facts) {
          ac[key] = ac[key] ? ac[key] + current.prev_months_facts[key] : current.prev_months_facts[key];
        }

        return ac;
      }, []),
      prev_months_average: categories.reduce((ac, current) => ac + current.prev_months_average, 0),
      current_month_prev_year_fact: categories.reduce((ac, current) => ac + current.current_month_prev_year_fact, 0),
      current_month_fact: categories.reduce((ac, current) => ac + current.current_month_fact, 0),
      current_month_plan: categories.reduce((ac, current) => ac + current.current_month_plan, 0),
      current_month_delta: categories.reduce((ac, current) => ac + current.current_month_delta, 0),
      weeks: categories.reduce((ac, current) => {
        for(const key in current.weeks) {
          if(!ac[key]) {
            ac[key] = {};
          }

          ac[key].plan = (ac[key].plan || 0) + current.weeks[key].plan;
          ac[key].fact = (ac[key].fact || 0) + current.weeks[key].fact;
        }

        return ac;
      }, []),
    };
    state.ds.unshift(summaryData);
  }

};

const getters: GetterTree<DeliverySheetBoardState, RootState> = {

};

export const STORE_KEY = '$_pipelines';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
